import { useMutation } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { CouponValidationResult, CouponValidationInput } from '../gql/graphql';
import { graphqlRequest } from '../utils/graphqlClient';

const validateCouponMutation = graphql(`
  mutation validateCoupon($input: CouponValidationInput!) {
    validateCoupon(input: $input) {
      isValid
      discountType
      discountValue
      discountAmount
      newTotalAmount
      message
    }
  }
`);

export default function useValidateCoupon() {
  return useMutation<CouponValidationResult, Error, CouponValidationInput>({
    mutationFn: async (input: CouponValidationInput) => {
      const result = await graphqlRequest<{
        validateCoupon: CouponValidationResult;
      }>(validateCouponMutation, { input }); // Public endpoint, no auth needed
      return result.validateCoupon;
    },
  });
}
